import { render } from "./session.details.vue?vue&type=template&id=e2e8cb4e"
import script from "./session.details.vue?vue&type=script&lang=js"
export * from "./session.details.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/tractus.web.clientapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__